import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yelloop.svg'


const _withScopeId = n => (_pushScopeId("data-v-658c08da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container pt-5" }
const _hoisted_2 = { class: "d-flex justify-content-center mb-1 heading pb-3 pb-sm-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-3\" data-v-658c08da><div class=\"line col-lg-3\" data-v-658c08da></div></div><h1 class=\"main-title text-center py-4 fw-bold txt-red\" data-v-658c08da>システムのアップデートに伴い、二段階認証が必須となりました。</h1><h1 class=\"main-title text-center fw-bold\" data-v-658c08da>コミュニティに入室する前に</h1><h1 class=\"main-title text-center pb-5 fw-bold\" data-v-658c08da>二段階認証の設定をお願いします。</h1>", 4)
const _hoisted_9 = { class: "d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { PATH } from '@/constants'
import { getCookie } from '@/utils'
import { debounce } from 'lodash'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const onNav = debounce(() => {
  const url = '/alumni/account/profile/edit'
  router.push({ path: url, query: { ...route.query, two_factor_enabled: route.query?.two_factor_enabled || 'false' } })
}, 200)
onMounted(() => {
  const basePath = PATH[`${route.path.split('/')[1]}`]
  const hasHeaders = getCookie(basePath?.header)
  const required2FA = getCookie(`${basePath.path}-required-two-factor`) === 'true'
  // 二段階認証未設定フラグがfalseの場合、ロビーに遷移
  if (hasHeaders && !required2FA) {
    router.push(`/${route.path.split('/')[1]}/lobby`)
    return
  }
  return
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('SD10heading')), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(Button, {
        title: "アカウント設定",
        type: 'secondary',
        className: 'me-2',
        onClick: _unref(onNav)
      }, null, 8, ["onClick"])
    ])
  ]))
}
}

})